import { render, staticRenderFns } from "./Contactblok.vue?vue&type=template&id=0c48894f&scoped=true&"
import script from "./Contactblok.vue?vue&type=script&lang=js&"
export * from "./Contactblok.vue?vue&type=script&lang=js&"
import style0 from "./Contactblok.vue?vue&type=style&index=0&id=0c48894f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48894f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
